import React, { InputHTMLAttributes } from "react";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
}

export default function Input({ className = "", ...props }: InputProps) {
  const baseClasses =
    "w-full rounded-xl border border-gray-200 px-5 py-4 text-sm text-[#0A2B1C] placeholder:text-gray-400 focus:border-[#063B66] focus:outline-none focus:ring-1 focus:ring-[#063B66]/20 bg-white transition-all disabled:opacity-50 disabled:bg-gray-50";

  const combinedClasses = `${baseClasses} ${className}`.trim();

  return <input className={combinedClasses} {...props} />;
}
